// src/components/dashboard/CurrencyToggle/CurrencyToggle.js - FIXED
import React, { useEffect, useState } from 'react';
import { useCurrency } from '../../../context/CurrencyContext';
import './CurrencyToggle.css';

const CurrencyToggle = () => {
  const { currency, toggleCurrency, loading } = useCurrency();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // ✅ Only show toggle after currency is loaded
    if (!loading) {
      // Small delay to ensure state is fully synced
      setTimeout(() => setIsReady(true), 100);
    }
  }, [loading]);

  // Show loading state while currency is being fetched
  if (loading || !isReady) {
    return (
      <div className="currency-toggle loading">
        <span className="currency-flag">🔄</span>
        <span className="currency-code">Loading...</span>
      </div>
    );
  }

  return (
    <div className="currency-toggle">
      <button 
        onClick={toggleCurrency}
        className="currency-toggle-btn"
        title={`Switch to ${currency === 'NGN' ? 'USD' : 'NGN'}`}
        aria-label={`Current currency: ${currency}. Click to switch to ${currency === 'NGN' ? 'USD' : 'NGN'}`}
      >
        <span className="currency-flag">
          {currency === 'NGN' ? '🇳🇬' : '🇺🇸'}
        </span>
        <span className="currency-code">
          {currency}
        </span>
        <span className="toggle-indicator">
          {currency === 'NGN' ? '→ USD' : '→ NGN'}
        </span>
      </button>
    </div>
  );
};

export default CurrencyToggle;